import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {HTTPAssistantRepository} from '../Repositories/HTTPAssistantRepository.js'

class GetAssistantChatSuggestionsUseCase extends UseCase {
  #assistantRepository

  constructor({assistantRepository}) {
    super()
    this.#assistantRepository = assistantRepository
  }

  static create({config}) {
    return new GetAssistantChatSuggestionsUseCase({
      assistantRepository: HTTPAssistantRepository.create({config})
    })
  }

  @tracer({metric: 'GetAssistantChatSuggestionsUseCase#execute'})
  @AsyncInlineError()
  async execute({type, chatId, adId}) {
    const [error, response] = await this.#assistantRepository.getSuggestions({type, chatId, adId})

    if (error) return Promise.reject(error)
    return response.toJSON()
  }
}

export const factory = GetAssistantChatSuggestionsUseCase.create
